module.exports = __webpack_public_path__ + "media/images/iconClose__inactive-8e2659bba69544e228a3b65af11b3d9d.png";